<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>

  <div v-else>
    <div
      class="ui very compact medium red button"
      style="background-color: #092442"
      @click="goToUpdatePatient()"
    >
      Update
    </div>

    <br />

    <div 
      class="ui item pointing menu"
      :class="{two: $auth.check('doctor') && !isAdmin(), three: $auth.check('employee') || isAdmin()}"
    >
      <a
        class="item"
        :class="{ active: currentTab === tabs.first }"
        @click="currentTab = tabs.first"
      >
        <i
          class="icon"
          :class="{
            female: Number(patientLog.gender) === 2,
            male: Number(patientLog.gender) === 1
          }"
        />
        Main information
      </a>
      <a
        class="item"
        :class="{ active: currentTab === tabs.second }"
        @click="currentTab = tabs.second"
        v-if="$auth.check('employee') || isAdmin()"
      >
        <i class="clipboard icon" />
        Applications
      </a>
      <a
        class="item"
        :class="{ active: currentTab === tabs.third }"
        @click="currentTab = tabs.third"
      >
        <i class="book icon" />
        Medical history
      </a>
    </div>

    <div
      style="margin-top: 20px; border-top: 2px solid #092442"
      class="ui segment"
    >
      <div style="margin-top: 10px;">
        <patientInfo :patient="patientLog" v-if="currentTab === tabs.first" />
        <applications
          :reservations="patientLog.reservations"
          :transactions="transactions"
          :visits="visits"
          :lastReservationsTransactions="lastReservationsTransactions"
          v-if="currentTab === tabs.second"
        />
        <patientMedicalHistory
          :visits="medicalHistoryVisits()"
          :packages="getPackages()"
          v-if="currentTab === tabs.third"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default,
    patientInfo: require('./patient_log_componenets/PatientInfo').default,
    applications: require('./patient_log_componenets/Applications').default,
    medicalHistory: require('./patient_log_componenets/MedicalHistory').default,
    patientMedicalHistory: require('./patient_log_componenets/PatientMedicalHistory')
      .default
  },
  data() {
    return {
      patientLog: {},
      visits: [],
      transactions: [],
      lastReservationsTransactions: [],
      loading: true,
      tabs: {
        first: 'patientInfo',
        second: 'applications',
        third: 'medicalHistory'
      },
      currentTab: 'applications'
    };
  },
  beforeMount() {
    this.$http.get(`patients/${this.$route.params.id}`).then(response => {
      this.patientLog = response.data.patient;
      this.visits = response.data.meta.visits;
      this.transactions = response.data.meta.transactions;
      this.lastReservationsTransactions = response.data.meta.last_reservations_transactions;
      this.loading = false;
    });
  },
  methods: {
    medicalHistoryVisits () {
      return this.visits.filter(visit => visit.doctor && visit.finished_at)
    },
    goToUpdatePatient() {
      this.navigateTo('Update_Patient', {
        key: 'params',
        value: { id: this.patientLog.id }
      });
    },
    removeEmpty(data) {
      return window._.filter(data, o => o && 'id' in o);
    },
    getAllVisits() {
      return window._.flatten(
        window._.map(
          this.patientLog.reservations,
          reservation => reservation.visits
        )
      );
    },
    getPackages() {
      return this.patientLog.reservations.flatMap(r => r.reservations_packages).map(rp => rp.package)
    }
  }
};
</script>

<style scoped>
.fixed-size {
  min-width: 220px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/patients/PatientLog.vue